import Dashboard from './dashboard';
import Tools from './tools';
import Querys from './query';
import Mail from './mail';
import SeniorTables from './senior-tables';

export default {
  Dashboard,
  Tools,
  Querys,
  Mail,
  SeniorTables,
};
